// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".absolute-full[data-v-098c8628] {\n  background: #fff;\n  z-index: 10000;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/TheShop.vue"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,cAAA;AAAJ","sourcesContent":["\n.absolute-full {\n    background: #fff;\n    z-index: 10000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
